import React from 'react'

import { CreateLabel } from 'modules/Labels/containers'
import { Layout } from 'components'

const LabelCreatePage = () => (
  <Layout>
    <CreateLabel />
  </Layout>
)

export default LabelCreatePage
